import { render } from "./ServicesPage.vue?vue&type=template&id=77cc4e62&bindings={}"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
script.render = render

export default script